var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_3650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9168 11.3334C16.7501 11.1667 16.6668 10.9168 16.6668 10.6668C16.6668 10.5001 16.6668 10.2501 16.6668 10.0834C16.6668 9.91675 16.6668 9.66679 16.6668 9.50012C16.6668 9.25012 16.7501 9.00008 16.9168 8.83341L18.3334 7.41679C18.5834 7.16679 18.6668 6.75006 18.5001 6.41673L17.5001 4.66675C17.3334 4.33341 16.9168 4.16675 16.5834 4.25008L14.6668 4.83348C14.4168 4.91681 14.1668 4.83341 13.9168 4.66675C13.5834 4.41675 13.2501 4.25012 12.8334 4.08346C12.5834 4.00012 12.4168 3.75006 12.3334 3.50006L11.8334 1.58346C11.7501 1.25012 11.4168 0.916748 11.0001 0.916748H9.0001C8.58343 0.916748 8.2501 1.16679 8.16677 1.58346L7.66677 3.50006C7.58343 3.75006 7.41677 3.91679 7.16677 4.08346C6.7501 4.25012 6.41677 4.50008 6.08343 4.66675C5.83343 4.83341 5.58343 4.83348 5.33343 4.83348L3.41677 4.25008C3.08343 4.16675 2.66677 4.33341 2.5001 4.66675L1.5001 6.41673C1.33343 6.75006 1.33343 7.16679 1.66677 7.41679L3.08343 8.83341C3.2501 9.00008 3.33343 9.25012 3.33343 9.50012C3.33343 9.66679 3.33343 9.91675 3.33343 10.0834C3.33343 10.2501 3.33343 10.5001 3.33343 10.6668C3.33343 10.9168 3.2501 11.1667 3.08343 11.3334L1.66677 12.7501C1.41677 13.0001 1.33343 13.4168 1.5001 13.7501L2.5001 15.5001C2.66677 15.8334 3.08343 16.0001 3.41677 15.9167L5.33343 15.3335C5.58343 15.2501 5.83343 15.3334 6.08343 15.5001C6.41677 15.7501 6.7501 15.9168 7.16677 16.0835C7.41677 16.1668 7.58343 16.4168 7.66677 16.6668L8.16677 18.5835C8.2501 18.9168 8.58343 19.2501 9.0001 19.2501H11.0001C11.4168 19.2501 11.7501 19.0001 11.8334 18.5835L12.3334 16.6668C12.4168 16.4168 12.5834 16.2501 12.8334 16.0835C13.2501 15.9168 13.5834 15.6667 13.9168 15.5001C14.1668 15.3334 14.4168 15.3335 14.6668 15.3335L16.5834 15.9167C16.9168 16.0001 17.3334 15.8334 17.5001 15.5001L18.5001 13.7501C18.6668 13.4168 18.6668 13.0001 18.3334 12.7501L16.9168 11.3334Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L9.46535 12L8 10.2857",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_3650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationWhite);
export default __webpack_public_path__ + "static/media/Integration_White.6a96ec4b090fcf8014a35da1dc41d786.svg";
export { ForwardRef as ReactComponent };